const KEYS = {
  INTRO: 13,
};

Object.freeze(KEYS);

export { KEYS };
